import React from 'react';
import { motion } from 'framer-motion';
import './styles/timeline.css';

/**
 * Dated entries on a vertical rail, shared by Education and Experiences so the
 * two sections read as one set. Items are `{ duration, title, subtitle, detail,
 * badge, current }`; entries fade in one after another as the rail scrolls in.
 */
export default function Timeline({ items }) {
  return (
    <ol className="timeline">
      {items.map((item, index) => (
        <motion.li
          key={`${item.duration}-${item.title}`}
          className={`timeline__item${item.current ? ' timeline__item--current' : ''}`}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.45, delay: index * 0.08, ease: 'easeOut' }}
          variants={{
            visible: { opacity: 1, x: 0 },
            hidden: { opacity: 0, x: -16 },
          }}
        >
          <span className="timeline__node" aria-hidden="true" />
          <div className="timeline__meta">
            <span className="timeline__duration">{item.duration}</span>
            {item.badge && <span className="timeline__badge">{item.badge}</span>}
          </div>
          <h3 className="timeline__title">{item.title}</h3>
          <p className="timeline__subtitle">{item.subtitle}</p>
          {item.detail && <p className="timeline__detail">{item.detail}</p>}
        </motion.li>
      ))}
    </ol>
  );
}
